import React from 'react';
import * as ReactDOM from 'react-dom';
import {
  compose,
  pipe,
  find,
  drop,
  append,
  uniqBy,
  concat,
  is,
  pick,
  reject,
  clone,
  isNil
} from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './engine.js';
import { CSSTransition } from 'react-transition-group';
import { Button } from '@synergycms_core/components/generic';

import { simplifyValueWithSpace, parseHotelsInfo } from '@synergycms_core/components/functional/Engine/engineUtils';
import EngineDropDownList from './EngineDropDownList';
import EngineDropDownOccup from './EngineDropDownOccup';
import EngineTop from './EngineTop';
import EngineDatepicker from './EngineDatepicker';
import EngineFileInfo from './EngineFileInfo';
import storage from '../../../utils/storage';
import MyReservation from './MyReservation';
import Cookies from '../../../utils/cookies.js';
import { addParamToURL, removeParamFromURL } from '../../../store/customer/paramsUtils.js';
import EngineBoxList from './EngineBoxList'
import EngineBoxDate from './EngineBoxDate'
import EngineBoxOccups from './EngineBoxOccups';
import EngineBoxPromo from './EngineBoxPromo';
import EngineBoxButton from './EngineBoxButton.jsx';
import moment from 'moment';


const engine = class Engine extends React.Component {
  static displayName = 'Engine';

  refSearchBox = 'searchBoxEngine';
  static getDerivedStateFromError(err) {
    console.log(err)
  }
  constructor(props) {
    super(props);
    this.cx = props.theme.bind();
    const { config } = props;
    this.searchObject = parseHotelsInfo(clone(config.hotelsInfo));

    this.hotelsInfo = this.searchObject && concat(this.searchObject.hotels, this.searchObject.destinations);
    if (config.engineSygyData) {
      config.engineSygyData.setNewMatch = this.setNewMatch;
      config.engineSygyData.setNewState = this.setNewState;
    }

    const match = this.getterDefaultMatch(config.params);
    const params = config.params || {};
    let visibleType = null;
    let dropDown = null;

    if (config.showModalView && this.isModalBreak()) {
      if (config.webType === 'PORTAL' && !match) {
        visibleType = 'list';
        dropDown = true;
      }
    }

    this.dropDownPositionMode = config.inAvail ? 'bottom' : params?.dropdown_position || 'bottom';
    this.occupsDropdownMaxHeight = params?.occups_dropdown_max_height || 400;

    this.state = {
      showModalView: config.showModalView,
      firstLoad: true,
      visibleType: visibleType,
      dropDown: dropDown,
      match: null,
      value: match ? match.name : '',
      selectedSearch: match,
      start: params.start || null,
      end: params.end || null,
      occups: params.occups || null,
      changeOccups: 0,
      promoCode: params.promotion_code || '',
      togglePromos: false,
      promoVisible: false,
      matchedText : '',
      calendarKey: 0,
      emptyMatch: false, //indica si no se selecciona destino/hotel al buscar
      engineMerged: false,
      dropDownPosition: this.dropDownPositionMode === 'auto' ? 'bottom' : this.dropDownPositionMode,
      //maxHeightAvailable: undefined,
    };

    this.initialEnd = config.params?.end || null;

    this.searchContainerRef = React.createRef();
    this.dropDownRef = React.createRef();
  }

  getterDefaultMatch = params => {
    //const hotelsInfo = this.props.config.hotelsInfo;
    const hotelsInfo = this.searchObject;
    let result = null;

    if (params.hotelCode || params.hotel_code || params.hotel_id) {
      const hotelCode = params.hotelCode || params.hotel_code;
      const hotelId = params.hotel_id;
      if (hotelsInfo) {
        result = find(hotel => hotel.code === hotelCode, hotelsInfo.hotels);
        if(!result)
          result = find(hotel => +hotel.id === +hotelId, hotelsInfo.hotels)
      } else if(hotelId) {
        result = { hotelId };
      } else {
        result = { hotelCode };
      }
    }

    if (!result && (params.city_id || params.cityId)) {
      const cityId = params.city_id || params.cityId;
      result = find(city => city.type === "city" && city.id.toString() === cityId.toString(), hotelsInfo.destinations);
    }

    if (!result && (params.country_id || params.countryId)) {
      const countryId = params.country_id || params.countryId;
      result = find(country => country.type === "country" && country.id.toString() === countryId.toString(),  hotelsInfo.destinations);
    }
    return result || null;
  };

  setNewMatch = paramsCallback => {
    const match = this.getterDefaultMatch(is(Function, paramsCallback) ? paramsCallback(this.props.config.params) : paramsCallback);
    this.selectSearch(match)(null);
  };

  setNewState = stateCallBack => {
    this.setState((state) => {
      const newState = is(Function, stateCallBack) ? stateCallBack(state) : stateCallBack;
      return pick(['showModalView', 'firstLoad', 'visibleType', 'dropDown', 'match', 'value', 'selectedSearch', 'start', 'end', 'occups', 'promoCode', 'engineMerged'], newState);
    });
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  isModalBreak = ()=>{
    return window.innerWidth < this.props.theme.themeValues.modalBreak;
  }

  componentDidMount() {
    this.enterEvent = e => {

      if (e.target.id !== this.refSearchBox && e.keyCode === 13) {
        this.selectSearch(null)(e);
        this.toggleBox(false)(e);
      }
    };
    this.element = ReactDOM.findDOMNode(this);
    window.addEventListener('keyup', this.enterEvent);


    if (!this.isMobile()) {
      document.addEventListener('click', this.propagateCloseDropDown);
    }

    if (this.isMobile() && this.props.theme.modelDevice === 'iPhone') {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 300);
    }

    if(this.dropDownPositionMode === 'auto') {
      const dropDownNode = ReactDOM.findDOMNode(this.dropDownRef.current);
      if (dropDownNode) {
        const observer = new MutationObserver(this.setDropDownPosition)
        window.addEventListener('scroll', this.setDropDownPosition)
        // In case the body has an overflow
        document.body.addEventListener('scroll', this.setDropDownPosition)

        observer.observe(dropDownNode, { childList: true, subtree: true });
      }
    }

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.visibleType !== this.state.visibleType) {
      this.focusDropDownContainer();
      this.getAriaHidden();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.enterEvent);
    document.removeEventListener('click', this.propagateCloseDropDown);
    window.removeEventListener('scroll', this.setDropDownPosition);
  }

  setDropDownPosition = () => {
    const dropDownNode = this.dropDownRef.current && ReactDOM.findDOMNode(this.dropDownRef.current);
    if (!dropDownNode || !this.searchContainerRef.current) return;

    const dropDownRect = dropDownNode.getBoundingClientRect();
    const searchRect = this.searchContainerRef.current.getBoundingClientRect();

    const distanceTop = searchRect.top - dropDownRect.height - 10;
    const distanceSearchToBottom = window.innerHeight - searchRect.bottom
    const distanceBottom = distanceSearchToBottom - dropDownRect.height - 10;

    this.setState({
      dropDownPosition: distanceBottom > 0 ? distanceSearchToBottom > 100 ? 'bottom': 'top' : distanceTop > 0 ? 'top' : 'bottom' // Default to bottom when overflowing on the top and bottom
      //maxHeightAvailable: Math.max(distanceTop, distanceBottom)
    });
  };

  setCurrentSearchList = (machedElement) => {
    if(this.state.matchedText !== machedElement.matchedText){
      this.setState(state => {
          return machedElement;
      });
    }
  }

  onChangeValue = event => {
    event.preventDefault();
    const value = event && event.target.value;

    if (this.state.visibleType !== "list" && !this.props.config.focusOnModalView) {
      this.toggleBox(true, "list")();
    }

    this.setState(state => {
        return { firstLoad: false, value, matchedText: value && state.matchedText, matchType:null, emptyMatch:false };
    });
  };

  onKeyDownSearchBox = e => {
    const key = e.key || e.keyCode;
    if ([9, 13, 'Tab', 'Enter'].includes(key)) {
      const simpleValue = simplifyValueWithSpace(e.target.value);
      let findValue = find(object => {
        return object.simpleText.indexOf(simpleValue) === 0;
      }, this.hotelsInfo);

      if (!findValue) {
        findValue = find(object => {
          return object.simpleText.indexOf(simpleValue) !== -1;
        }, this.hotelsInfo);
      }

      if (findValue) {
        this.selectSearch(findValue)();
      }
    }
  };

  selectSearch = (selectedMatch, matchType = null) => e => {
    e && e.preventDefault();
    const currentMatch = selectedMatch || this.state.match;
    if (selectedMatch || this.state.match) {
      this.setState(state => {
        const availLastSearch = storage.getLocal('avai_last_search') || [];
        if (availLastSearch.length < 3) {
          storage.setLocal(
            'avail_last_search',
            pipe(
              append(currentMatch),
              uniqBy(obj => obj.name)
            )(availLastSearch)
          );
        } else {
          storage.setLocal(
            'avail_last_search',
            pipe(
              drop(1),
              append(currentMatch),
              uniqBy(obj => obj.name)
            )(availLastSearch)
          );
        }
        this.props.config.selectSearch && this.props.config.selectSearch(currentMatch, (this.isMobile() ? 4 : 2));

        let visibleType = selectedMatch && !matchType ? 'datepicker' : state.visibleType
        if(!this.isMobile() && selectedMatch && !matchType){ //si tras seleccionar destino/hotel se tenia ya fecha, no abrir datepicker
          visibleType =  ( !this.state.start || !this.state.end ) ? 'datepicker' : null;
        }

        return {
          match: currentMatch,
          selectedSearch: currentMatch,
          value: currentMatch.name,
          matchType: matchType,
          visibleType: visibleType,
          matchedText:'',
          emptyMatch: false,
          dropDown: true,
        };
      });
    }
  };

  clearSearch = () => {
    this.setState({ value: '', match: null });
  };

  clearStorage = () => {
    storage.setLocal('avail_last_search', []);
    this.forceUpdate();
  };

  updateOccups = occups => {
    this.setState(state => {
      return { occups: occups, changeOccups: state.changeOccups + 1 };
    });
    if(this.dropDownPositionMode === 'auto') {
      setTimeout(() => {
        const dropDownNode = ReactDOM.findDOMNode(this.dropDownRef.current);
        if (dropDownNode) {
          const height = dropDownNode.getBoundingClientRect().height;
          this.setDropDownPosition(height)
        }
      }, 300);
    }
  };

  updatePromoCode = promoCode => {
    this.setState(state => {
      return { promoCode: promoCode };
    }, () => {
      this.toggleBox(false)();
      if(promoCode){
        this.executeSearch();
        if(!this.props.config.inAvail){
          Cookies.set('promotion_code', promoCode, 30);
          addParamToURL('promotion_code', promoCode);
        }
      } else if(!promoCode && !this.props.config.inAvail){
        Cookies.unset('promotion_code');
        removeParamFromURL('promotion_code');
      }
    });
  };

  updateRange = range => {
    const { start, end, calendarKey } = this.state;

    if (start && !end && range.start && !range.end && range.start === start) {
      this.setState({ start: undefined, end: undefined, calendarKey: calendarKey + 1 });
      return;
    }

    this.setState({ start: range.start, end: range.end });

    if (range.start && range.end) {
      this.setState({ visibleType: 'occups' });
    }
  };

  toggleBox = (open, visibleType) => e => {

    e && e.preventDefault();
    this.setState(state => {
      if (open === null) {
        open = visibleType !== state.visibleType ? true : !state.dropDown;
      }
      if (this.isMobile() && !state.showModalView && state.selectedSearch) {
        open = false;
      }

      if (visibleType && visibleType !== 'list') {
        this.selectSearch(null)();
      }

      return {
        promoVisible: false,
        showModalView: true,
        dropDown: open,
        visibleType: visibleType || state.visibleType
      };
    }, () => {

      if (open && visibleType !== 'promo') {
        this.focusDropDownContainer();
      }

      if (visibleType && visibleType === 'promo') {
        this.togglePromos(open);
      }
      if (this.isMobile() && this.props.theme.modelDevice === 'iPhone') {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 300);
      }
    });
  };

  focusDropDownContainer = () => {
    const { visibleType } = this.state;
    const dropDownElement = document.getElementById('dropDownContainer');
    const promoContainer = document.getElementById('promoContainer');

    if (visibleType === 'list') {
      return;
    }

    if (visibleType === 'promo' && promoContainer) {
      promoContainer.focus();
    }

    if (dropDownElement) {
      dropDownElement.focus();
    }

  };

  getAriaLabel = () => {
    const { visibleType, end, selectedSearch } = this.state;
    const { content } = this.props;

    const ariaLabels = {
      list: content.t('_%busca destino%_'),
      datepicker: content.t('_%elige fecha%_'),
      occups:content.t('_%elige ocupantes%_'),
      promo: content.t('_%codigo promo%_'),
    };

    return ariaLabels[visibleType] || '';
  };

  getAriaHidden = () => {
    const { visibleType, end, selectedSearch} = this.state;
    const { content } = this.props;

    const isEndChange = this.initialEnd !== end;

    const formatEnd = isEndChange ? moment(end).format('dddd D MMMM, YYYY') + '  ' + content.t('_%salida%_')  : '';

    const selecMatch = selectedSearch ? selectedSearch.name : '';

    const labelHidden = {
      list: '',
      datepicker: selecMatch,
      occups: formatEnd,
      promo: '',
    };

    return labelHidden[visibleType] || '';
  }

  closeModalView = (e) => {
    e && e.preventDefault();
    const visibleType = (this.props.config.webType === 'PORTAL') ? 'list' : 'datepicker';

    if (this.isModalBreak() && this.state.showModalView && !this.state.dropDown) {
      if (!this.props.config.showEngine) {
        this.setState(() => {
          return { showModalView: false, dropDown: false, visibleType: visibleType };
        });
      } else {
        this.props.config.showEngine(false);
      }
    } else if (this.isModalBreak() && this.state.showModalView) {
      this.restoreLastSelected();
      this.setState(() => {
        return { dropDown: false, visibleType: visibleType, promoVisible: false };
      });
    } else {
      this.props.config.showEngine && this.props.config.showEngine(false);
    }
  };

  restoreLastSelected = () => {
    this.setState(() => {
      return { value: this.state.selectedSearch ? this.state.selectedSearch.name : '', matchedText : '' };
    });
  };

  executeSearch = e => {
    e && e.preventDefault();
    const selected = this.state.selectedSearch;
    if (selected && this.state.start && this.state.end) {
      this.props.config.executeSearch(this.state);
      this.toggleBox(false)();
    }

    if (!selected) {  // No se ha seleccionado destino/hotel
      this.setState(state => {
        return { emptyMatch: true }; // No se ha realizado aun busqueda por destino/hotel
      }, () => {
        this.toggleBox(true, 'list')();
      });
    } else if (!this.state.start || !this.state.end) { // No se ha seleccionado fecha
      this.toggleBox(true, 'datepicker')();
    }
  };

  propagateCloseDropDown = e => {
    if (!e || (this.element.contains && document.contains && !this.element.contains(e.target) && document.contains(e.target))) {
      if(this.state.dropDown){
        this.restoreLastSelected();
        this.toggleBox(false)();
      }
    }
  };

  togglePromos = (promoVisible) => {
    return this.setState({ promoVisible: promoVisible });
  };

  showBoxList = () => {
    const { config, theme } = this.props;
    const { webType  } = config
    const {
      value,
      showModalView,
    } = this.state;

    if(webType === 'WI') return false;
    if(this.hotelInfoData) return false;
    if(this.isModalBreak() && !showModalView && theme.theme === 'portalDesign' && value) return false;
    return true
  }

  showBoxDate = () => {
    const { config, theme } = this.props;
    const { outerWeb  } = config
    const {
      value,
      showModalView,
    } = this.state;

    if (!this.isModalBreak()) return true;
    if(showModalView) return true;
    if(outerWeb) return true;
    if(this.isMobile() && this.hotelInfoData) return true
    if(theme.theme === 'portalDesign' && value) return true

    return false;
  }

  showBoxOccups = () => {
    const {
      showModalView,
    } = this.state;

    if (!this.isModalBreak()) return true;
    if(showModalView) return true;

    return false;
  }

  showBoxPromo = () => {
    const {
      showModalView,
    } = this.state;

    const promoEnabled = this.promoManager.enabled
    if(!promoEnabled) return false;

    if (!this.isModalBreak()) return true;
    if (showModalView) return true;

    return false;
  }

  showBoxButton = () => {
    const { theme } = this.props;
    const { showModalView } = this.state;

    if (!this.isModalBreak()) return true;
    if(showModalView) return true;
    if(this.isModalBreak() && theme.theme === 'portalDesign') return true;

    return false;
  }

  showMobileFooter = (myBookingUrl) => {
    const { showModalView } = this.state;
    const { group } = this.props.config;
    if(group === 'eurostarshotels') return false;
    return {
      footer: this.isMobile() && !showModalView,
      promo: this.promoManager.enabled && !this.hotelInfoData,
      myReservation: !!myBookingUrl,
    }
  }

  setPromoManager = () => {
    const { config, content } = this.props;
    const { extraInfo } = config;
    const { promoVisible, promoCode } = this.state;

    const enablePromoCode = extraInfo?.enable_promotion_code ? extraInfo.enable_promotion_code : content.getLinks('promoCode');
    //const hidePromotionCode = group === 'eurostarshotels' && this.isMobile() && !showModalView;

    this.promoManager = {
      enabled: enablePromoCode, //&& !hidePromotionCode ,
      togglePromos: this.togglePromos,
      promoVisible: promoVisible,
      updatePromoCode: this.updatePromoCode,
      promoCode: promoCode
    };

  }

  //TOP links only in desk version y no avail
  setTopLinkList = () => {
    const { config, content } = this.props;
    const { inAvail } = config

    this.linksList = []

    if(!this.isMobile()  && !inAvail){
     this.linksList =
      reject((val) => isNil(val.url))([
        content.getLinks('hotelFly', ['top']),
        content.getLinks('transportLink'),
        content.getLinks('activitiesLink'),
        content.getLinks('rentLink'),
        content.getLinks('loginLink', ['top']),
        content.getLinks('transfersLink')]);
    }
  }

  //Information in the left box of the engine
  setLeftEngineBox = () => {
    const { config, content } = this.props;
    const { inAvail } = config
    const { selectedSearch } = this.state

    this.showLeftEngineBox = false
    this.hotelFlyInHotelInfo = null,
    this.hotelInfoData = false,
    this.hotelsInfoDesc = null,
    this.selectedStars = null

    if(!inAvail && !this.isMobile()){
      this.hotelFlyInHotelInfo =  content.getLinks('hotelFly', ['hotelInfo', 'left']);
      let textLeftEngine = content.getLinks('engine_left_title', null, true, null, this.props.config);
      let descLeftEngine = content.getLinks('engine_left_subtitle', null, true, null, this.props.config);

      this.hotelInfoData = textLeftEngine ? textLeftEngine : content.getLinks('hotelInfo', null, this.hotelFlyInHotelInfo?.url, null, this.props.config);
      if(this.hotelInfoData)
        this.hotelsInfoDesc = descLeftEngine ? descLeftEngine : content.getLinks('hotelInfoDesc');
      this.selectedStars = (selectedSearch && selectedSearch.stars !== null) ? selectedSearch.stars : '';

      this.showLeftEngineBox = !!((this.hotelInfoData || this.hotelFlyInHotelInfo?.url))

    }
  }

  getEngine = () => {
    const { config, theme, content } = this.props;
    const { classes } = theme.styles;
    const { webType, group, inAvail, engineVisible, focusOnModalView, dropDownListType, limits, childsInfo } = config;
    const {
      value,
      match,
      start,
      end,
      visibleType,
      occups,
      firstLoad,
      dropDown,
      selectedSearch,
      showModalView,
      matchedText,
      matchType,
      emptyMatch,
      changeOccups,
      calendarKey,
    } = this.state;

    const DatepickerComponent = this.props.config.DatepickerComponent || EngineDatepicker;

    const showEngine = !this.isMobile() || (this.isMobile() && (engineVisible || showModalView))

    if(!showEngine) return null;

    this.setLeftEngineBox()
    this.setPromoManager()
    this.setTopLinkList()

    let myBookingUrl = null
    if(!inAvail) myBookingUrl = content.getLinks('my_booking', null, true, null, this.props.config) || content.getLinks('myBooking');
    const hotelsCatalog = this.props.config.extraInfo?.hotels_catalog  ? this.props.config.extraInfo?.hotels_catalog : content.getLinks('hotelsCatalog');

    const showMobileFooter = this.showMobileFooter(myBookingUrl)

    const groupEurostar = config.group === 'eurostarshotels' || config.group === 'eurostarshotelcompany';
    return <div
      className={[
        theme.computedInnerStyle,
        (!this.hotelInfoData && webType !== 'WI') ? classes.engineHomeContainer : classes.engineFileContainer,
        this.cx({
          promoWiMode: !(webType === 'PORTAL' && !this.hotelInfoData && this.promoManager.enabled) && !this.hotelsInfoDesc,
          dispoModal:this.isModalBreak() && showModalView,
          inDispoContainer: inAvail,
          promoWiModeSmall: !(webType === 'PORTAL' && !this.hotelInfoData && this.promoManager.enabled) && !this.hotelsInfoDesc && !this.linksList.length && this.hotelFlyInHotelInfo?.url,
          engineMerged: this.state.engineMerged
        }),
      ].join(' ')}
      >
      {!!this.linksList.length && (
        <EngineTop
          linksList={this.linksList}
          myBookingUrl={myBookingUrl}
          showModalView={showModalView}
        />
      )}
      <div className={classes.engineContainerOpen}>
        <div className={classes.engine}>
          <div className={this.hotelInfoData ? classes.wrapperContainerHotelFile : classes.wrapperContainerDispo}>
            <div>
              {(inAvail || (showModalView && this.isModalBreak())) && (
                <Button
                  onClick={this.closeModalView}
                  innerStyle={this.cx({closeButton:showModalView, closeButtonClose:!showModalView})}
                  icon={{ unicodeContent: 'e001' }}
                  ariaLabel={'_%cerrar busqueda%_'}
                  translate={true}
                />
              )}
              <div className={[classes.searchContainer, this.cx({searchContainerSlim:this.hotelInfoData})].join(' ')} ref={this.searchContainerRef}>
                {this.showLeftEngineBox  && (
                  <EngineFileInfo
                    hotelInfo={this.hotelInfoData}
                    hotelInfoDesc={this.hotelsInfoDesc}
                    hotelFlyUrl={this.hotelFlyInHotelInfo?.url}
                    hotelStars={this.selectedStars}
                  />
                )}


                {( this.showBoxList() &&
                  <EngineBoxList
                    value={value}
                    match={match}
                    visibleType={visibleType}
                    dropDown={dropDown}
                    showModalView={showModalView}
                    matchedText={matchedText}
                    focusOnModalView={focusOnModalView}
                    toggleBox={this.toggleBox}
                    clearSearch={this.clearSearch}
                    onChangeValue={this.onChangeValue}
                    onKeyDownSearchBox={this.onKeyDownSearchBox}
                    modalBreak={this.isModalBreak()}
                  />
                )}


                {( this.showBoxDate() &&
                  <EngineBoxDate
                    start={start}
                    end={end}
                    visibleType={visibleType}
                    dropDown={dropDown}
                    showModalView={showModalView}
                    toggleBox={this.toggleBox}
                    modalBreak={this.isModalBreak()}
                    innerStyle={[
                      !(webType === 'PORTAL' && !this.hotelInfoData && this.promoManager.enabled) && !this.hotelsInfoDesc  && 'promoWiMode',
                      (!this.hotelInfoData && webType === 'WI') && 'engineFileContainer',
                      this.isModalBreak() && showModalView && 'dispoModal'
                    ]}
                    inAvail={inAvail}
                    engineMerged={this.state.engineMerged}
                  />
                )}

                {(this.showBoxOccups() &&
                  <EngineBoxOccups
                    occups={occups}
                    visibleType={visibleType}
                    dropDown={dropDown}
                    toggleBox={this.toggleBox}
                    changeOccups={changeOccups}
                    modalBreak={this.isModalBreak()}
                    innerStyle={[
                      !(webType === 'PORTAL' && !this.hotelInfoData && this.promoManager.enabled) && !this.hotelsInfoDesc  && 'promoWiMode',
                      (!this.hotelInfoData && webType === 'WI') && 'engineFileContainer',
                      this.isModalBreak() && showModalView && 'dispoModal',
                      !this.showBoxPromo() && 'promoDisable'
                    ]}
                  />
                )}

                {(this.showBoxPromo() &&
                  <EngineBoxPromo
                    promoManager={this.promoManager}
                    visibleType={visibleType}
                    dropDown={dropDown}
                    showModalView={showModalView}
                    toggleBox={this.toggleBox}
                    engineMerged={this.state.engineMerged}
                    modalBreak={this.isModalBreak()}
                    innerStyle={[
                      !(webType === 'PORTAL' && !this.hotelInfoData && this.promoManager.enabled) && !this.hotelsInfoDesc  && 'promoWiMode',
                      (!this.hotelInfoData && webType === 'WI') && 'engineFileContainer',
                      this.isModalBreak() && showModalView && 'dispoModal'
                    ]}
                    dropDownPosition={this.state.dropDownPosition}
                  />
                )}

                {this.showBoxButton() && (
                  <EngineBoxButton
                    selectedSearch={selectedSearch}
                    start={start}
                    end={end}
                    visibleType={visibleType}
                    dropDown={dropDown}
                    showModalView={showModalView}
                    executeSearch={this.executeSearch}
                    closeModalView={this.closeModalView}
                    engineMerged={this.state.engineMerged}
                    modalBreak={this.isModalBreak()}
                    />
                )}
              </div>

              <div className={[this.cx({engineMerged: this.state.engineMerged && (visibleType === 'datepicker')}), classes.dropDownDispo,this.state.dropDownPosition === 'top' ? classes.dropDownDispoTop : classes.dropDownDispoBottom].join(' ')} ref={this.dropDownRef}>
                <span id='dropDownContainer' tabIndex={0} aria-label={this.getAriaHidden()}></span>
                <CSSTransition
                  aria-label={this.getAriaLabel()}
                  tabIndex={0}
                  in={dropDown}
                  timeout={groupEurostar ? 0 : 500}
                  mountOnEnter={visibleType !== 'datepicker'}
                  unmountOnExit={visibleType !== 'datepicker'}
                  classNames={{
                    enter: visibleType === 'datepicker' ? classes.dropDownEnterDatepicker : classes.dropDownEnter,
                    enterActive:  visibleType === 'datepicker' ? classes.dropDownEnterActiveDatepicker : classes.dropDownEnterActive,
                    exit:  visibleType === 'datepicker' ? classes.dropDownLeaveDatepicker : classes.dropDownLeave,
                    exitActive:  visibleType === 'datepicker' ? classes.dropDownLeaveActiveDatepicker : classes.dropDownLeaveActive,
                    exitDone:  visibleType === 'datepicker' ? classes.dropDownExitDoneDatepicker : undefined
                  }}>
                  <div
                    className={[
                      this.isModalBreak() ? classes.dropDownDispoMobile : classes.animationContainer,
                      this.cx({
                        [visibleType]:
                          visibleType !== 'list' ||
                          (this.state.emptyMatch) ||
                          (storage.getLocal('avail_last_search') || []).length ||
                          (firstLoad && !value && (storage.getLocal('avail_last_search') || []).length) ||
                          (!firstLoad && value) || dropDownListType === 'nested_destinations'
                      },{ [classes.startSelected]: (start && !end) })
                    ].join(' ')}>
                    {visibleType === 'list' && (
                      <EngineDropDownList
                        clearStorage={this.clearStorage}
                        firstLoad={firstLoad}
                        selectSearch={this.selectSearch}
                        type={dropDownListType}
                        value={value}
                        group={group}
                        setCurrentSearchList={this.setCurrentSearchList}
                        searchList={this.searchObject}
                        match={match}
                        matchType={matchType}
                        hotelsCatalog={hotelsCatalog}
                        emptyMatch={emptyMatch}
                        modalBreak={this.isModalBreak()}
                      />
                    )}
                    {visibleType === 'datepicker' && (
                      <DatepickerComponent
                        occups={occups}
                        onChangeCalendar={config.onChangeCalendar}
                        selectedSearch={this.state.selectedSearch}
                        hideBoards={config.hideBoards}
                        inAvail={inAvail}
                        onRangeChange={this.updateRange}
                        start={start}
                        end={end}
                        months={this.isModalBreak() ? 3 : 2}
                        webType={webType}
                        key={calendarKey}
                      />
                    )}
                    {visibleType === 'occups' && (
                      <EngineDropDownOccup
                        childsInfo={childsInfo}
                        updateOccups={this.updateOccups}
                        occups={occups}
                        limits={limits}
                        executeSearch={this.executeSearch}
                        modalBreak={this.isModalBreak()}
                        maxHeight={this.occupsDropdownMaxHeight}
                      />
                    )}
                  </div>
                </CSSTransition>
              </div>
            </div>
          </div>
        </div>
      </div>


      {showMobileFooter.footer && (
        <div className={classes.engineFooter}>
          {showMobileFooter.promo && (
            <div className={classes.engineFooterElement}>
              <EngineBoxPromo
                promoManager={this.promoManager}
                classes={classes}
                showModalView={showModalView}
                toggleBox={this.toggleBox}
                modalBreak={this.isModalBreak()}
              />
            </div>
          )}

          {showMobileFooter.myReservation  && (
            <div className={classes.engineFooterElement}>
              <MyReservation myBookingUrl={myBookingUrl}  />
            </div>
          )}

        </div>
      )}

    </div>;
  };

  render() {
    return this.getEngine();
  }
};

export default compose(
  PropertyManager([
    'params',
    'executeSearch',
    'match',
    'hotelsInfo',
    'inAvail',
    'webType',
    'outerWeb',
    'showModalView',
    'focusOnModalView',
    'engineVisible',
    'showEngine',
    'group',
    'links',
    'lang',
    'engineSygyData',
    'limits',
    'childsInfo',
    'corporateLogin',
    'selectSearch',
    'onChangeCalendar',
    'DatepickerComponent',
    'hideBoards',
    'dropDownListType',
    'extraInfo',
    'modalBreak'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent(['links', 'i18n'])
)(engine);
